const getUserData = () => {
  try {
    const userDataString = localStorage.getItem("oidc.user:https://id.hle.com.tw:js");
    if (!userDataString) {
      // 如果沒有儲存的使用者資料，返回預設值
      return {
        name: "測試使用者",
        email: "test@example.com",
        sub: "test-user-id"
      };
    }

    const userData = JSON.parse(userDataString);
    const profile = userData?.profile;

    // 智能處理不同 OIDC 登入格式的名稱
    let name = "測試使用者";
    if (profile) {
      // 優先使用 firstName + lastName
      if (profile.firstName && profile.lastName) {
        name = `${profile.lastName}${profile.firstName}`;
      }
      // 如果 name 是 UUID，嘗試使用 preferred_username
      else if (profile.name && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(profile.name)) {
        name = profile.preferred_username || profile.name;
      }
      // 使用非 UUID 的 name
      else if (profile.name && !Array.isArray(profile.name)) {
        name = profile.name;
      }
      // 處理陣列格式的 name
      else if (Array.isArray(profile.name) && profile.name.length > 0) {
        name = profile.name[0];
      }
      // 最後嘗試 preferred_username
      else if (profile.preferred_username) {
        name = profile.preferred_username;
      }
    }

    const email = profile?.email || "test@example.com";
    const sub = profile?.sub || "test-user-id";

    return { name, email, sub };
  } catch (error) {
    console.error('解析使用者資料失敗:', error);
    // 發生錯誤時返回預設值
    return {
      name: "測試使用者",
      email: "test@example.com",
      sub: "test-user-id"
    };
  }
};

export { getUserData };